import authService from "src/helpers/authService";
import { User } from "src/store/User";

export function authZ_eventRoster_bulkAddPlayersAsEligibleToRegister() : boolean {
  return authService(User.userData?.roles ?? [], "registrar", "webmaster");
}
